import { render, staticRenderFns } from "./portrait.vue?vue&type=template&id=40c4fa84&scoped=true&"
import script from "./portrait.vue?vue&type=script&lang=js&"
export * from "./portrait.vue?vue&type=script&lang=js&"
import style0 from "./portrait.vue?vue&type=style&index=0&id=40c4fa84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c4fa84",
  null
  
)

export default component.exports